
import { createSlice } from "@reduxjs/toolkit";

import { getCartProductsWebuser } from "../../reduxApi/website/CartProductCount";
const initialState = {
  data: [], // This will store the cart products
  loading: false,
  error: null,
  message: ""
};

const WebUserCartSlice = createSlice({
  name: "CartProducts",
  initialState,
  reducers: {
    clearCartData: (state) => {
      state.data = [];
      state.message = "Cart is empty";
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle getCartProductsWebuser
      .addCase(getCartProductsWebuser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCartProductsWebuser.fulfilled, (state, action) => {
        state.loading = false;
        // Store the data from the API response
        const payload = action.payload;

  state.data =
    payload?.data?.carts ||   // nested carts
    payload?.data ||          // direct data array
    payload?.carts ||         // carts at root
    [];

  state.message = payload?.message || "Cart fetched successfully";

  console.log("WebUserCartSlice updated:", state.data);
        // state.data = action.payload?.data || [];
        // state.message = action.payload?.message || "Cart fetched successfully";
        // console.log("WebUserCartSlice updated:", state.data);
      })
      .addCase(getCartProductsWebuser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch cart";
        state.data = [];
      });
  }
});

export const { clearCartData } = WebUserCartSlice.actions;
export default WebUserCartSlice.reducer;

// import { createSlice } from "@reduxjs/toolkit";
// import { getCartProductsWebuser } from "../../reduxApi/website/CartProductCount";


// const initialState = {
//   CartProducts: {
//     data: [],
//     carts: []
//   },
//   loading: false,
//   error: null
// };

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     // ... your existing reducers
//   },
//   extraReducers: (builder) => {
//     builder
//       // Handle getCartProductsWebuser
//       .addCase(getCartProductsWebuser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(getCartProductsWebuser.fulfilled, (state, action) => {
//         state.loading = false;
//         // Store the data in CartProducts.data
//         state.CartProducts = {
//           ...state.CartProducts,
//           data: action.payload?.data || [],
//           message: action.payload?.message
//         };
//         console.log("Cart data stored in Redux:", state.CartProducts);
//       })
//       .addCase(getCartProductsWebuser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload || "Failed to fetch cart";
//         state.CartProducts.data = [];
//       });
//   }
// });

// export default cartSlice.reducer;